
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateEventInvitationDtoFormGroup() {
return new FormGroup({
    eventId: new FormControl<number | undefined>(undefined, [Validators.required]),
    audienceId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    gender: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    company: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    firstName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    email: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    eventInvitationTypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      